import React, { Component, Fragment } from 'react';
import { langCheck } from 'Pub/js/utils';

export default function MultiSelection(props) {
	return (
		<Fragment>
			<li className='nc-theme-xrow-bgc' onClick={props.checkAllCard}>
				{/*全选*/}
				{langCheck('ZoneSetting-000270', 'pages', props.json)}
			</li>
			<li onClick={props.clearCheckedCard}>
				{/*全消*/}
				{langCheck('ZoneSetting-000271', 'pages', props.json)}
			</li>
			<li onClick={props.moveCardFront}>
				{/*移动于前*/}
				{langCheck('ZoneSetting-000272', 'pages', props.json)}
			</li>
			<li onClick={props.moveCardBehind}>
				{/*移动于后*/}
				{langCheck('ZoneSetting-000273', 'pages', props.json)}
			</li>
			<li onClick={props.revertThisAction}>
				{/*取消*/}
				{langCheck('ZoneSetting-000274', 'pages', props.json)}
			</li>
		</Fragment>
	)
}
